<template>
  <div :class="{ 'has-logo': showLogo, 'horizontal-class': sidebarView }">
    <template v-if="!sidebarView">
      <logo v-if="showLogo" :collapse="isCollapse" />
    </template>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <template v-if="sidebarView">
          <sidebar-item
            v-for="route in childrenMenu"
            :key="route.path"
            :item="route"
            :base-path="route.path"
            :onlyChild="true"
          />
        </template>
        <template v-else>
          <sidebar-item
            v-for="route in permission_routes"
            :key="route.path"
            :item="route"
            :base-path="route.path"
            :onlyChild="false"
          />
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";

export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      childrenMenu: [],
      title: "",
    };
  },
  watch: {
    route_id: {
      handler(id) {
        this.childrenMenu = this.permission_routes.filter((item) => {
          if (!item.hidden) {
            // 暂时做限制
            if (id === "/dashboard" || id === "/statistical-analysis") {
              // 找到首页列表
              if (item.path === "/") {
                return item.children.find((it) => {
                  return "/" + it.path === id;
                });
              }
            } else {
              return item.path === id;
            }
            return item.path === id;
          }
        });
        // 没有匹配到任何页面 给个保底首页
        if (this.childrenMenu.length === 0) {
          this.$store.commit("permission/SET_ROUTE_ID", "/dashboard");
          this.childrenMenu = this.permission_routes.filter((item) => {
            return item.path === "/";
          });
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["permission_routes", "sidebar", "route_id", "sidebarView"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .router-link-active {
  background-color: #ffffff;
  border-right: 2px solid #409eff;
  // background-color: #e6f7ff;
  // border-right: 2px solid #409eff;
}

.title {
  height: 52px;
  line-height: 52px;
  border-bottom: 2px solid #f1f1f1;
  margin-bottom: 10px;
  span {
    font-size: 20px;
    margin-left: 10px;
    font-weight: 700;
  }
}
.horizontal-class {
  margin-top: 50px;
}
</style>
